import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(work)/work/page.tsx")